import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import {
    getOrder,
    updateAdminDeliveryNote,
    updateAdminOrderConfirm,
    updateAdminOrderCourier,
    updateAdminOrderStatus,
    updateAdminPrice
} from '../../store/action/order';
import {
    nextStatus,
    normalizeTrackingStatus
} from '../../services/helpers/status'
import moment from 'moment'
import CourierDetailsForm from "../../components/forms/CourierDetailsForm";
import DeliveryNoteForm from "../../components/forms/DeliveryNoteForm";
import { Button, Modal } from "react-bootstrap";

const AdminOrderDetail = (props) => {
    const { user, token } = isAuthenticated();
    const [show, setShow] = useState(false);
    const [modalType, setModalType] = useState('info');
    const [ order, setOrder ] = useState({
        orderId: "",
        destination: {
            coordinate: {
                latitude: '',
                longitude: ''
            }
        },
        delivery: {},
        courier: {
            history: [],
            note: '-'
        },
        items: [],
        note: "",
        origin: {},
        price: "",
        shipper: "",
        status: "",
    });
    const [values, setValues] = useState({
        courierTrackingId:"",
        courierWaybillId:"",
        courierName:"",
        courierPhone:"",
        courierType:"",
        courierCompany:"",
        deliveryNote:"",
        items:[],
        price:0
    });


    useEffect(() => {
        _fetchData()
    }, []);

    const _fetchData = async () => {
        const res = await getOrder(token, props.match.params.orderId);
        if (res.success) {
            let courierHistory = res.courier.history.reduce((result,i) => {
                result.push({
                    serviceType: i.service_type,
                    status: normalizeTrackingStatus(i.status),
                    note:i.note,
                    updatedAt:i.updated_at
                });
                return result
            },[]);

            let data = {
                orderId: res.id,
                destination: {
                    contactName: res.destination.contact_name,
                    contactPhone: res.destination.contact_phone,
                    contactEmail: res.destination.contact_email,
                    address: res.destination.address,
                    note: res.destination.note,
                    proofOfDelivery: res.destination.proof_of_delivery,
                    coordinate: res.destination.coordinate
                },
                delivery: res.delivery,
                courier: {
                    trackingId: res.courier.tracking_id,
                    waybillId: res.courier.waybill_id,
                    company: res.courier.company,
                    link: res.courier.link,
                    name: res.courier.name,
                    phone: res.courier.phone,
                    history: courierHistory,
                    status: res.courier.status,
                    type: res.courier.type
                },
                items: res.items,
                note: res.note,
                origin: {
                    contactName: res.origin.contact_name,
                    contactPhone: res.origin.contact_phone,
                    contactEmail: res.origin.contact_email,
                    address: res.origin.address,
                    note: res.origin.note,
                    coordinate: res.origin.coordinate
                },
                price: res.price,
                shipper: res.shipper,
                status: normalizeTrackingStatus(res.status)
            };
            setOrder(data)
        } else {
            return alert("Gagal mengambil data. Coba refresh atau ulangi beberapa saat lagi")
        }
    };

    const onPressRejectStatus = async () => {
        let data = {
            courierTrackingId: order.courier.trackingId,
            courierWaybillId: order.courier.waybillId,
            courierType: order.courier.type,
            courierCompany: order.courier.company,
            courierLink: order.courier.link,
            courierName: order.courier.name,
            courierPhone: order.courier.phone
        };

        if(window.confirm('Kamu yakin mau tolak order?')) {
            updateAdminOrderStatus(token, order.orderId, 'rejected', data)
                .then(res => {
                    if(res.success){
                        alert(`Sudah Diganti ke status ${res.status}`);
                        _fetchData()
                    } else {
                        alert(res.error)
                    }
                })
        }
    };

    const handleModalClose = () => setShow(false);
    const handleModalShow = (modalType) => {
        setModalType(modalType);
        setShow(true);
    };

    const onPressUpdateStatus = async () => {
        let data = {
            courierTrackingId: order.courier.trackingId,
            courierWaybillId: order.courier.waybillId,
            courierType: order.courier.type,
            courierCompany: order.courier.company,
            courierLink: order.courier.link,
            courierName: order.courier.name,
            courierPhone: order.courier.phone
        };

        if(order.status === 'allocated' && !order.courier.name) {
            alert("Kamu belum memasukan nama dan nomor telpon kurir");
            return
        }

        if (order.status === 'placed') {
            if(window.confirm(`Kamu yakin mau confirm order pelanggan?`)) {
                updateAdminOrderConfirm(token, order.orderId, 'confirmed')
                    .then(res => {
                        if(res.success){
                            alert(`Sudah Diganti ke status ${res.order.status}`);
                            _fetchData()
                        } else {
                            alert(res.error)
                        }
                    })
            }
        } else {
            if(window.confirm('Kamu yakin mau update status?')) {
                let newStatus = await nextStatus(order.status);
                updateAdminOrderStatus(token, order.orderId, newStatus, data)
                    .then(res => {
                        if(res.success){
                            alert(`Sudah Diganti ke status ${res.status}`);
                            _fetchData()
                        } else {
                            alert("error")
                        }
                    })
            }
        }
    };

    const onSubmitDeliveryNote = () => {
        updateAdminDeliveryNote(token, order.orderId, values.deliveryNote)
            .then(data => {
                if(data.success){
                    setShow(false);
                    alert(`Berhasil update status pengiriman`);
                    _fetchData();
                    setShow(false)
                } else {
                    alert("Error. Gagal update status pengiriman")
                }
            })
    };

    const onSubmitCourierDetails = () => {
        let data = {
            courierTrackingId: order.courier.trackingId,
            courierWaybillId: values.courierWaybillId,
            courierName: values.courierName,
            courierPhone: values.courierPhone
        };
        updateAdminOrderCourier(token, order.orderId, data)
            .then(data => {
                if(data.error) {
                    setValues({...values, error: data.error})
                } else {
                    setValues({
                        ...values,
                        courierWaybillId:"",
                        courierName:"",
                        courierPhone:"",
                        courierType:"",
                        courierCompany:""
                    });
                    alert('Kurir berhasil diupdate');
                    setShow(false);
                    _fetchData()
                }
            })
    };

    const onSubmitPriceChange = async () => {
        updateAdminPrice(token, order.orderId, values.price)
            .then(data => {
                if(data.error) {
                    setValues({...values, error: data.error})
                } else {
                    setValues({
                        ...values,
                        price:0
                    });
                    alert('Harga berhasil diganti');
                    setShow(false);
                    _fetchData()
                }
            })
    };

    const handleChange = name => e => {
        const value = e.target.value;
        setValues({ ...values, error:false, success:false, [name]: value });
    };

    const modal = () => {
        let form;
        let onClick;
        let title;
        if (modalType === 'info') {
            title = 'Masukkan Info';
            onClick = () => onSubmitCourierDetails();
            form = (
                <CourierDetailsForm
                    handleChange={handleChange}
                    values={values}
                />
            );
        } else if (modalType === 'deliveryNote'){
            title = 'Masukkan Detail Kurir';
            onClick = () => onSubmitDeliveryNote();
            form = (
                <DeliveryNoteForm
                    handleChange={handleChange}
                    values={values}
                />
            );
        } else if (modalType === 'priceChange') {
            title = 'Masukkan Harga Baru';
            onClick = () => onSubmitPriceChange();
            form = (
                <div className="form-group">
                    <input
                        type="number"
                        onChange={handleChange('price')}
                        placeholder="Harga Baru"
                        className="form-control"
                        value={values.price}
                    />
                </div>
            )
        }

        return (
            <Modal show={show} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <h5>
                        { title }
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    { form }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary btn-sm" onClick={handleModalClose}>
                        Tutup
                    </Button>
                    <Button variant="primary btn-sm" onClick={onClick}>
                        Simpan
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    const updateButtonCourier = () => {
        if (order.status === 'delivered') {
            return null
        }
        return (
            <div className="row">
                <div className="col-6">
                    <button onClick={() => onPressUpdateStatus()} className="btn btn-primary mt-4 btn-block">
                        Update Status
                    </button>
                </div>
                <div className="col-6">
                    <button onClick={() => onPressRejectStatus()} className="btn btn-danger mt-4 btn-block">
                        Tolak Status
                    </button>
                </div>
            </div>
        )
    };

    return (
        <div className="bg-white rounded shadow p-4">
            { modal() }
            <div className="py-4">
                <div className=" d-flex justify-content-between">
                    <h5>Detail Pesanan Nomor: {order.orderId} <span className="badge badge-warning"> {order.status}</span></h5>
                    <button
                        className="btn btn-primary"
                        onClick={() => window.location.assign('/admin/orders')}
                    >
                        Kembali ke Menu
                    </button>
                </div>
            </div>

            <div className="row">
                <div className="col-6">
                    <h6>Detail Pesanan </h6>
                    <p>Pengirim: <b>{order.shipper.name} </b></p>
                    <p>Email: <b>{order.shipper.email} </b></p>
                    <p>Telepon: <b>{order.shipper.phone} </b></p>
                    <p>Organisasi: <b>{order.shipper.organization} </b></p>
                    <hr/>
                    <div className="row">
                        <div className="col-6">
                            <h6>Lokasi Asal</h6>
                            <p>Name: <b>{order.origin.contactName}</b></p>
                            <p>Telepon: <b>{order.origin.contactPhone}</b></p>
                            <p>Email: <b>{order.origin.contactEmail}</b></p>
                            <p>Alamat: <b>{order.origin.address}</b></p>
                            <p>Catatan: <b>{order.origin.note}</b></p>
                            <p>Surat Jalan: <b>{order.origin.proofOfDelivery}</b></p>
                        </div>
                        <div className="col-6">
                            <h6>Lokasi Tujuan</h6>
                            <p>Name: <b>{order.destination.contactName}</b></p>
                            <p>Telepon: <b>{order.destination.contactPhone}</b></p>
                            <p>Email: <b>{order.destination.contactEmail}</b></p>
                            <p>Alamat: <b>{order.destination.address}</b></p>
                            <p>Catatan: <b>{order.destination.note}</b></p>
                        </div>
                    </div>
                    <hr/>
                    <h6>Info Pengiriman</h6>
                    <p>Pengiriman: <b>{order.delivery.datetime}</b></p>
                    <hr/>
                    <h6>Info Lainnya <span onClick={() => handleModalShow('priceChange')} className="badge badge-danger btn"> Edit</span></h6>
                    <p>Harga: <b>{order.price}</b></p>
                    <hr/>
                    <h6>Info Barang</h6>
                    {
                        order.items.map((i,idx) => (
                            <div className="card">
                                <h6>Barang {idx+1}</h6>
                                <div className="row">
                                    <div className="col-4">
                                        <p>Nama: <b>{i.name}</b></p>
                                        <p>Deskripsi: <b>{i.description}</b></p>
                                        <p>Panjang: <b>{i.length}</b></p>
                                    </div>
                                    <div className="col-4">
                                        <p>Lebar: <b>{i.width}</b></p>
                                        <p>Tinggi: <b>{i.height}</b></p>
                                        <p>Berat: <b>{i.weight}</b></p>
                                    </div>
                                    <div className="col-4">
                                        <p>Jumlah: <b>{i.quantity}</b></p>
                                        <p>Nilai Barang: <b>{i.value}</b></p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className="col-6">
                    <h6>Info Kurir <span onClick={() => handleModalShow('info')} className="badge badge-danger btn"> Edit</span></h6>
                    <div className="row">
                        <div className="col-6">
                            <p>Tracking Id: <b>{order.courier.trackingId}</b></p>
                            <p>Waybill Id: <b>{order.courier.waybillId}</b></p>
                            <p>Perusahaan: <b>{order.courier.company}</b></p>
                            <p className="mb-0">Link Pesanan Kurir: <b>{order.courier.link}</b></p>
                        </div>
                        <div className="col-6">
                            <p>Name: <b>{order.courier.name}</b></p>
                            <p>Telepon: <b>{order.courier.phone}</b></p>
                            <p>Status: <b>{order.courier.status}</b></p>
                            <p className="mb-0">Alamat: <b>{order.courier.type}</b></p>
                        </div>
                    </div>
                    <p className="mt-3 mb-0">Info Kurir: {order.delivery.note} <span onClick={() => handleModalShow('deliveryNote')} className="badge badge-danger btn"> Tambah Info</span></p>
                    <hr/>
                    <h6>Info Status</h6>
                    {
                        order.courier.history.map((i,idx) => (
                            <div className="card mb-1">
                                <div className="row">
                                    <div className="col-6">
                                        <p className="mb-0"><b>{moment(i.updatedAt).format('YYYY-MM-DD HH:mm:ss')}</b></p>
                                    </div>
                                    <div className="col-6">
                                        <p className="mb-0"><b>{i.status}</b></p>
                                    </div>
                                </div>
                                <div>
                                    <p>{i.note}</p>
                                </div>
                            </div>
                        ))
                    }
                    { updateButtonCourier() }
                </div>
            </div>
        </div>
    )
};


export default AdminOrderDetail;
